module.exports = __webpack_public_path__ + "static/media/14.102.41109d4b.webp";